export default "__VITE_PUBLIC_ASSET__18411bd4__"